import { render, staticRenderFns } from "./AccountsReceivableCard.vue?vue&type=template&id=496b3a38&"
import script from "./AccountsReceivableCard.vue?vue&type=script&lang=js&"
export * from "./AccountsReceivableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports